import { ProcesName } from './ProcesHandlerHelpers';
import { ProcesHandler } from '../../interfaces/FormConfig';
import { FormProps, FormState } from '../FormContainer';

export class PopupProcessHandlerHelpers {
    static getProcesses(): ProcesHandler[] {
        return [
            
            {
                procesName: ProcesName.PopupOnOk,
                execute: (
                    component: React.Component<FormProps, FormState>,
                    data: any,
                    onSuccess,
                    onError
                ) => {
                  
                    if (component.props.onPopupOkClick) {
                        component.props.onPopupOkClick().then(() => {
                            onSuccess(data); 
                        });
                    } else {
                        onSuccess(data); 
                    }
                                                                                           
                }
            }
        ];
    }
}
